import { lazy } from 'react';

export default {
  exact: false,
  name: 'GIMAC Transfer Money',
  protected: true,
  path: '/gimac-transfer-money',
  component: lazy(() => import('containers/Gimac/TransferMoney')),
};
